import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { Link } from "react-router"
import { Text } from "@/components/ui/baseUi/text"

type LoginBackProps = {
  className?: string
  emailState?: string
} & React.ComponentProps<"div">

export function LoginBack({ className, emailState, ...props }: LoginBackProps) {
  return (
    <div className={cn("flex flex-1 items-end justify-center text-center", className)} {...props}>
      <div>
        <Text className="text-neutral-500">{word("auth.form.account")} </Text>

        <Button
          variant="underline"
          className="px-1"
          nativeButton={false}
          render={
            <Link to={Path.Login} state={emailState ? { email: emailState } : undefined}>
              <Text fontStyle="BM" className="font-semibold">
                {word("auth.form.signin")}
              </Text>
            </Link>
          }
        />
      </div>
    </div>
  )
}
